import { DecimalPipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { SelectedProduct } from '../../models/selected-product';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-cart-item',
  imports: [DecimalPipe, FontAwesomeModule, RouterLink, NgIf],
  templateUrl: './cart-item.html',
  styleUrl: './cart-item.scss',
  standalone: true,
})
export class CartItem {
  @Input() item!: SelectedProduct;
  @Output() increase = new EventEmitter<any>();
  @Output() decrease = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();

  faPlus = faPlus;
  faMinus = faMinus;

  onIncrease() {
    this.increase.emit(this.item);
  }

  onDecrease() {
    this.decrease.emit(this.item);
  }

  onRemove() {
    this.remove.emit(this.item);
  }

  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = '/placeholder.svg';
  }
}
